
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/review-guidelines",
      function () {
        return require("private-next-pages/terms/review-guidelines.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/review-guidelines"])
      });
    }
  